/* import __COLOCATED_TEMPLATE__ from './controls.hbs'; */
/* RESPONSIBLE TEAM: team-proactive-support */
import { action } from '@ember/object';
import Component from '@glimmer/component';
import type Graph from '../../models/graph-editor/graph';

interface Args {
  graph: Graph;
}

export default class GraphEditorControlsComponent extends Component<Args> {
  get zoomFactor(): number {
    return this.args.graph.settings.scale.zoomFactor;
  }

  get state() {
    return this.args.graph.state;
  }

  @action zoomIn(): void {
    this.args.graph.state.zoomIn(this.zoomFactor);
  }

  @action zoomOut(): void {
    this.args.graph.state.zoomOut(this.zoomFactor);
  }

  @action resetZoom(): void {
    this.args.graph.state.resetZoom();
  }
}
